import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

// テキストラッパー
const TextWrapper = styled.span`
  position: relative;
  display: inline-block;
`;

// アニメーション付きのボーダー
const Border = styled.span`
  position: absolute;
  bottom: -4px; // 文字のすぐ下に配置
  left: 50%;
  width: ${props => props.$isActive || props.$isHovered ? "100%" : "0"};
  height: 2px;
  background-color: var(--soremo-light-gray);
  transform: translateX(-50%);
  transition: width 0.3s ease;
  transform-origin: center;
`;

// メニュー項目のスタイル
const NavItemWrapper = styled.li`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0 8px;
`;

/**
 * ナビゲーション項目コンポーネント
 * @param {string} label - 表示するテキスト
 * @param {string} path - クリック時に遷移するパス
 * @param {boolean} isActive - アクティブ状態を示すフラグ
 * @param {function} onClick - クリック時のコールバック
 * @param {string} className - 追加のクラス名
 * @returns {JSX.Element}
 */
const NaviItem = ({ 
  label, 
  path, 
  isActive = false, 
  onClick,
  className = "bodytext-1113"
}) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  
  const handleClick = () => {
    if (path) {
      navigate(path);
    }
    if (onClick) {
      onClick(label);
    }
  };
  
  return (
    <NavItemWrapper 
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={className}
    >
      <TextWrapper>
        {label}
        <Border $isActive={isActive} $isHovered={isHovered} />
      </TextWrapper>
    </NavItemWrapper>
  );
};

export default NaviItem; 